import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pagination'
})
export class PaginationPipe implements PipeTransform {

  transform<T>(value: T[] | null | undefined, page: number, limit: number): T[] {
    if (!value) return new Array<T>();
   
    const start = (page - 1) * limit;
    const end = page * limit;
 
    return value.slice(start, end);
  }

}
